import { TagList } from '@xing-com/crate-jobs-domain-serps-components-tag-list';
import { capitalizeFirstLetter } from '@xing-com/crate-jobs-domain-serps-helpers';
import {
  useSeoLinkBoxes,
  useSerpsMatch,
} from '@xing-com/crate-jobs-domain-serps-hooks';

// The FE controls which link-box kinds are supported and which static key they use.
export const LINK_BOX_HEADER_COPY_KEYS: Record<string, string> = {
  employment_type_job_roles:
    'XJM_SEO_LINK_BOXES_LOCATION_MOST_SOUGHT_AFTER_JOB_TITLES',
  job_role_employment_type: 'XJM_SEO_LINK_BOXES_JOB_ROLE_EMPLOYMENT_TYPE',
  job_role_employment_type_employment_types:
    'XJM_SEO_LINK_BOXES_JOB_ROLE_EMPLOYMENT_TYPE',
  job_role_employment_type_related_job_roles:
    'XJM_SEO_LINK_BOXES_RELATED_JOB_ROLES',
  job_role_related_skills: 'XJM_SEO_LINK_BOXES_JOB_ROLE_RELATED_SKILLS',
  local_job_role_related_job_roles:
    'XJM_SEO_LINK_BOXES_LOCAL_JOB_ROLE_RELATED_JOB_ROLES',
  local_skill: 'XJM_SEO_LINK_BOXES_LOCAL_SKILL',
  local_skill_related_job_roles:
    'XJM_SEO_LINK_BOXES_LOCAL_SKILL_RELATED_JOB_ROLES',
  location_employment_type: 'XJM_SEO_LINK_BOXES_LOCATION_EMPLOYMENT_TYPE',
  location_employment_type_employment_types:
    'XJM_SEO_LINK_BOXES_LOCATION_EMPLOYMENT_TYPE',
  location_employment_type_nearby_locations:
    'XJM_SEO_LINK_BOXES_NEAR_BY_LOCATION',
  location_most_sought_after_job_titles:
    'XJM_SEO_LINK_BOXES_LOCATION_MOST_SOUGHT_AFTER_JOB_TITLES',
  near_by_location: 'XJM_SEO_LINK_BOXES_NEAR_BY_LOCATION',
  nearby_job_role: 'XJM_SEO_LINK_BOXES_NEARBY_JOB_ROLE',
  popular_location: 'XJM_SEO_LINK_BOXES_POPULAR_LOCATION',
  related_job_roles: 'XJM_SEO_LINK_BOXES_RELATED_JOB_ROLES',
  skill_related_job_roles: 'XJM_SEO_LINK_BOXES_SKILL_RELATED_JOB_ROLES',
  skill_related_skills: 'XJM_SEO_LINK_BOXES_SKILL_RELATED_SKILLS',
  skill_top_locations: 'XJM_SEO_LINK_BOXES_SKILL_TOP_LOCATIONS',
};

export const LINK_BOX_KINDS_WITH_COUNTS: string[] = [
  'employment_type_job_roles',
  'popular_location',
  'job_role_employment_type',
  'job_role_employment_type_employment_types',
  'location_employment_type',
  'location_employment_type_employment_types',
  'location_most_sought_after_job_titles',
  'skill_top_locations',
];

type LinkBoxCountProps = {
  showCount: 'hide' | 'show';
  showEmptyResults: 'hide' | 'show';
};

export const getLinkBoxCountProps = (kind: string): LinkBoxCountProps => {
  const showCount = LINK_BOX_KINDS_WITH_COUNTS.includes(kind);

  return {
    showCount: showCount ? 'show' : 'hide',
    showEmptyResults: showCount ? 'hide' : 'show',
  };
};

export const LinkBoxes: React.FC = () => {
  const serps = useSerpsMatch();
  const { data } = useSeoLinkBoxes();

  return (
    <>
      {data?.map((item) => {
        const headerCopyKey = LINK_BOX_HEADER_COPY_KEYS[item.kind];

        return headerCopyKey ? (
          <TagList
            key={item.kind}
            headerCopyKey={headerCopyKey}
            headerCopyValues={{
              categoryValue: capitalizeFirstLetter(serps?.categoryValue || ''),
              subcategoryValue: capitalizeFirstLetter(
                serps?.subcategoryValue || ''
              ),
            }}
            serpsList={item.entries}
            {...getLinkBoxCountProps(item.kind)}
          />
        ) : null;
      })}
    </>
  );
};
